import { SET_ERROR_STATE } from '../actions/types';

const defaultState = {
  hasError: false
};

export default function errorsReducers(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ERROR_STATE: {
      const { hasError: newErrorOccurred } = payload;
      const { hasError } = state;

      if (hasError !== newErrorOccurred) {
        return {
          ...state,
          hasError: newErrorOccurred,
        };
      }

      return state;
    }

    default: {
      return state;
    }
  }
}
